import React, { useCallback, useState } from 'react';

export function useInputFieldSetter(
    defaultValue: string,
    callback?: (value: string) => void,
): [string, (event: React.ChangeEvent<HTMLInputElement>) => void, (value: string) => void] {
    const [value, setValue] = useState(defaultValue);
    const setter = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            setValue(event.currentTarget.value);
            if (callback) {
                callback(event.currentTarget.value);
            }
        },
        [callback],
    );

    return [value, setter, setValue];
}

export function useCheckboxFieldSetter(
    isDefaultChecked: boolean,
): [boolean, (event: React.ChangeEvent<HTMLInputElement>) => void, (isChecked: boolean) => void] {
    const [isChecked, setIsChecked] = useState(isDefaultChecked);
    const setter = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        setIsChecked(event.currentTarget.checked);
    }, []);

    return [isChecked, setter, setIsChecked];
}
